var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wac-tag-filter',{attrs:{"headline":_vm.headline}},_vm._l((_vm.tags),function(tag,idx){return _c('a',{key:idx,attrs:{"href":tag.url}},[_c('wac-tag',{attrs:{"label":tag.label,"selected":tag.selected},on:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
return _vm.onClick.apply(void 0, argsArray.concat( [idx] ))}}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }